import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { urlValidation } from '../utils/urls';

import { ValidatedLinkOutput } from 'types/accounts';
import { ErrorModal } from 'types/modalTypes';

async function fetchurlValidation({ url }: TVariables): Promise<TResult> {
  if (!url)
    return new Promise((resolve, reject) => {
      reject();
    });
  const response = await fetch(urlValidation(url), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: ValidatedLinkOutput;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  url: string;
};

function useGetUrlValidation(url: string): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_url_validation',
    async () => {
      const fetchResponse = await fetchurlValidation({
        url,
      });
      return fetchResponse;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetUrlValidation };
